/**
 * video-lazy-load.js
 *
 * Defers loading of background/ambient videos (class="js-lazy-video") until
 * they are near the viewport. Prevents ~16 MB of eager video downloads on the
 * AIRLOCK One product page.
 *
 * Works by:
 *  1. Rendering videos with preload="none" and NO autoplay attribute in Liquid.
 *  2. Using IntersectionObserver to detect when each video approaches the viewport.
 *  3. Switching to preload="auto", loading, then playing.
 *
 * Fallback: if IntersectionObserver is unavailable (old browsers), all lazy
 * videos are loaded immediately so they still work.
 */
(function () {
  'use strict';

  function loadVideo(video) {
    if (video.dataset.lazyLoaded) return;
    video.dataset.lazyLoaded = '1';
    video.setAttribute('preload', 'auto');
    video.load();
    video.addEventListener(
      'canplay',
      function () {
        video.play().catch(function () {
          // Autoplay blocked by browser policy — that's fine, poster still shows.
        });
      },
      { once: true }
    );
  }

  function initLazyVideos() {
    var videos = document.querySelectorAll('video.js-lazy-video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      // Graceful degradation: load everything upfront on old browsers.
      videos.forEach(loadVideo);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (!video.dataset.lazyLoaded) {
              loadVideo(video);
            } else if (video.paused) {
              // Resume loops that were paused while offscreen (iOS auto-pause,
              // low-power mode, or a pauseAllMedia() call elsewhere on the page).
              video.play().catch(function () {});
            }
          }
        });
      },
      {
        // Start loading 400 px before the element scrolls into view so the
        // video is ready before the user actually sees it.
        rootMargin: '400px 0px',
        threshold: 0,
      }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyVideos);
  } else {
    initLazyVideos();
  }
})();
